<template>
  <a :href="href" :class="{ 'pointer-events-none': isLoading, 'ajax': mode === 'ajax' }" v-ajax-on-before="ajaxBefore" v-ajax-on-success="ajaxSuccess" v-ajax-on-error="ajaxError">
    <aw-icon
      v-if="isLoading"
      icon="loading"
      class="animate-spin w-5 h-5 "
    />
    <aw-icon
      v-else
      :icon="icon"
      class="w-5 h-5"
      :class="iconClass"
    />
    {{ isLoading && loadingText ? $t(loadingText) : text }}
  </a>
</template>
<script>
export default {
  data() {
    return {
      statusLoading: false,
    }
  },
  props: {
    mode: {
      type: String,
      required: false,
      default: 'manual',
    },
    href: {
      type: String,
      required: false,
      default: '#',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    loadingText: {
      type: String,
      required: false,
      default: null,
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconClass: {
      type: [String, Object],
      default: '',
    },
    before: {
      type: Function,
      required: false,
    },
    error: {
      type: Function,
      required: false,
    },
    success: {
      type: Function,
      required: false,
    },
  },
  computed: {
    isLoading() {
      return this.mode === 'manual'
        ? this.loading
        : this.statusLoading
    }
  },
  methods: {
    ajaxBefore(settings) {
      this.statusLoading = true
      if (this.before) {
        return this.before(settings)
      }
    },
    ajaxError(error, settings) {
      this.statusLoading = false
      if (this.error) {
        this.error(error, settings)
      }
    },
    ajaxSuccess(payload, response, settings) {
      this.statusLoading = false
      if (this.success) {
        this.success(payload, response, settings)
      }
    },
  }
}
</script>